import styled from "styled-components"
import media from "styled-media-query"
import Img from "gatsby-image"

export const GalleryBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-left: -12px;
  margin-right: -12px;
`
export const GalleryItem = styled.span`
  width: 25%;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  max-height: 150px;
  cursor: pointer;

  ${media.lessThan("medium")`
    width: 33.3333%;
  `}

  ${media.lessThan("small")`
    width: 50%;
  `}
`

export const Image = styled(Img)`
  height: 100%;
  width: 100%;
`
export const GalleryWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  padding: 16px 0;
  width: 100%;
  height: 100vh;
  background-color: var(--mainTransparent);

  ${media.greaterThan("medium")`
    padding: 32px 0;
  `}
`
export const GalleryModal = styled.div`
  width: 94%;
  max-width: 600px;
  height: auto;
  padding: 16px;
  background-color: white;
  border-radius: 10px;
  margin: 0px auto;

  ${media.greaterThan("medium")`
    padding: 48px;
    height: 100%;
  `}
`

export const LgImage = styled(Img)`
  height: 100%;
`
